import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import WarehouseMiddleware from '../../../../middleware/modules/master/warehouse';
import Warehouse from '../../../../components/modules/master/warehouse';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
// middlewares


const mapStateToProps = ({ auth,branch }) => ({
  isProcessing: branch.isProcessing,
  isError: branch.isError,
  errorMessage: branch.errorMessage,
  datalist:branch.data,
  showModal:branch.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>WarehouseMiddleware.create(),
    reset: () =>WarehouseMiddleware.resetList(),
    search: data =>WarehouseMiddleware.list(data),
    update: data =>WarehouseMiddleware.update(data),
    delete: (id,search) =>WarehouseMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class WarehouseContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Warehouse List")}
          </title>
        </Helmet>
      <Warehouse
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseContainer);
